import AppConstants from '../config/app.constants';

let RestoreRouteAssignmentService = function ($http, $q) {

    let getLocationRouteChange = (searchText, branchId, offset, limit) => {
        return $http
            .get(AppConstants.api + `/restore-route-assignments/get-location-route-change`, {
                params: {
                    searchText,
                    branchId,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };


    let undoLocationRouteChange = (data, branchId, userId) => {
        return $http
            .post(AppConstants.api + `/restore-route-assignments/undo-location-route-change`, {
                data,
                branchId,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        getLocationRouteChange,
        undoLocationRouteChange
    };
};

RestoreRouteAssignmentService.$inject = ['$http', '$q']

export default RestoreRouteAssignmentService;


// WEBPACK FOOTER //
// ./client/app/services/restore-route-assignment.service.js